export default "__VITE_ASSET__BLPbGCIj__"